import { UNATTRIBUTED } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/EventsTab/index.constants';
import type { SoftphoneEvent } from 'Modules/softphone/services/EventService';

/**
 * Narrows an event buffer to one leg.
 *
 * `null` means "all legs"; `UNATTRIBUTED` means the events that belong to no
 * call at all — registration and device events.
 */
export const filterEventsByLeg = (
  events: SoftphoneEvent[],
  selectedLeg: string | null
): SoftphoneEvent[] => {
  if (selectedLeg === null) {
    return events;
  }

  if (selectedLeg === UNATTRIBUTED) {
    return events.filter((event) => !event.callId && !event.conferenceId);
  }

  return events.filter(
    (event) =>
      event.callId === selectedLeg || event.conferenceId === selectedLeg
  );
};
